import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconArchive from '@/icons/Archive.svg';

export const RequestAutomaticallyArchivedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'request_automatically_archived'>;
}) => {
  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="danger"
      icon={<IconArchive />}
      message={
        <BaseActivityText>
          <Trans id="activities.request_automatically_archived.message">
            The request has been automatically archived
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
